// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/files.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/files.proto.
 */
export const file_chalk_server_v1_files: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.File
 */
export type File = Message<"chalk.server.v1.File"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.FileType file_type = 3;
   */
  fileType: FileType;

  /**
   * @generated from field: string owner_id = 4;
   */
  ownerId: string;

  /**
   * @generated from field: string environment_id = 5;
   */
  environmentId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 8;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: chalk.server.v1.FileVisibility file_visibility = 9;
   */
  fileVisibility: FileVisibility;
};

/**
 * Describes the message chalk.server.v1.File.
 * Use `create(FileSchema)` to create a new message.
 */
export const FileSchema: GenMessage<File> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 0);

/**
 * @generated from message chalk.server.v1.CreateFileRequest
 */
export type CreateFileRequest = Message<"chalk.server.v1.CreateFileRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.FileType file_type = 2;
   */
  fileType: FileType;

  /**
   * owner_id is automatically set to the authenticated user
   *
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;
};

/**
 * Describes the message chalk.server.v1.CreateFileRequest.
 * Use `create(CreateFileRequestSchema)` to create a new message.
 */
export const CreateFileRequestSchema: GenMessage<CreateFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 1);

/**
 * @generated from message chalk.server.v1.CreateFileResponse
 */
export type CreateFileResponse = Message<"chalk.server.v1.CreateFileResponse"> & {
  /**
   * @generated from field: chalk.server.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message chalk.server.v1.CreateFileResponse.
 * Use `create(CreateFileResponseSchema)` to create a new message.
 */
export const CreateFileResponseSchema: GenMessage<CreateFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 2);

/**
 * @generated from message chalk.server.v1.GetFileRequest
 */
export type GetFileRequest = Message<"chalk.server.v1.GetFileRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.GetFileRequest.
 * Use `create(GetFileRequestSchema)` to create a new message.
 */
export const GetFileRequestSchema: GenMessage<GetFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 3);

/**
 * @generated from message chalk.server.v1.GetFileResponse
 */
export type GetFileResponse = Message<"chalk.server.v1.GetFileResponse"> & {
  /**
   * @generated from field: chalk.server.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message chalk.server.v1.GetFileResponse.
 * Use `create(GetFileResponseSchema)` to create a new message.
 */
export const GetFileResponseSchema: GenMessage<GetFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 4);

/**
 * @generated from message chalk.server.v1.UpdateFileRequest
 */
export type UpdateFileRequest = Message<"chalk.server.v1.UpdateFileRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message chalk.server.v1.UpdateFileRequest.
 * Use `create(UpdateFileRequestSchema)` to create a new message.
 */
export const UpdateFileRequestSchema: GenMessage<UpdateFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 5);

/**
 * @generated from message chalk.server.v1.UpdateFileResponse
 */
export type UpdateFileResponse = Message<"chalk.server.v1.UpdateFileResponse"> & {
  /**
   * @generated from field: chalk.server.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message chalk.server.v1.UpdateFileResponse.
 * Use `create(UpdateFileResponseSchema)` to create a new message.
 */
export const UpdateFileResponseSchema: GenMessage<UpdateFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 6);

/**
 * @generated from message chalk.server.v1.DeleteFileRequest
 */
export type DeleteFileRequest = Message<"chalk.server.v1.DeleteFileRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.DeleteFileRequest.
 * Use `create(DeleteFileRequestSchema)` to create a new message.
 */
export const DeleteFileRequestSchema: GenMessage<DeleteFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 7);

/**
 * @generated from message chalk.server.v1.DeleteFileResponse
 */
export type DeleteFileResponse = Message<"chalk.server.v1.DeleteFileResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteFileResponse.
 * Use `create(DeleteFileResponseSchema)` to create a new message.
 */
export const DeleteFileResponseSchema: GenMessage<DeleteFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 8);

/**
 * @generated from message chalk.server.v1.ListFilesFilter
 */
export type ListFilesFilter = Message<"chalk.server.v1.ListFilesFilter"> & {
  /**
   * @generated from field: optional chalk.server.v1.FileType file_type = 1;
   */
  fileType?: FileType;
};

/**
 * Describes the message chalk.server.v1.ListFilesFilter.
 * Use `create(ListFilesFilterSchema)` to create a new message.
 */
export const ListFilesFilterSchema: GenMessage<ListFilesFilter> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 9);

/**
 * @generated from message chalk.server.v1.ListFilesRequest
 */
export type ListFilesRequest = Message<"chalk.server.v1.ListFilesRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: optional chalk.server.v1.ListFilesFilter filter = 2;
   */
  filter?: ListFilesFilter;

  /**
   * @generated from field: optional string cursor = 3;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.ListFilesRequest.
 * Use `create(ListFilesRequestSchema)` to create a new message.
 */
export const ListFilesRequestSchema: GenMessage<ListFilesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 10);

/**
 * @generated from message chalk.server.v1.ListFilesResponse
 */
export type ListFilesResponse = Message<"chalk.server.v1.ListFilesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.File files = 1;
   */
  files: File[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListFilesResponse.
 * Use `create(ListFilesResponseSchema)` to create a new message.
 */
export const ListFilesResponseSchema: GenMessage<ListFilesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 11);

/**
 * @generated from message chalk.server.v1.ArchiveFileRequest
 */
export type ArchiveFileRequest = Message<"chalk.server.v1.ArchiveFileRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.ArchiveFileRequest.
 * Use `create(ArchiveFileRequestSchema)` to create a new message.
 */
export const ArchiveFileRequestSchema: GenMessage<ArchiveFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 12);

/**
 * @generated from message chalk.server.v1.ArchiveFileResponse
 */
export type ArchiveFileResponse = Message<"chalk.server.v1.ArchiveFileResponse"> & {
  /**
   * @generated from field: chalk.server.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message chalk.server.v1.ArchiveFileResponse.
 * Use `create(ArchiveFileResponseSchema)` to create a new message.
 */
export const ArchiveFileResponseSchema: GenMessage<ArchiveFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 13);

/**
 * @generated from message chalk.server.v1.UnarchiveFileRequest
 */
export type UnarchiveFileRequest = Message<"chalk.server.v1.UnarchiveFileRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.UnarchiveFileRequest.
 * Use `create(UnarchiveFileRequestSchema)` to create a new message.
 */
export const UnarchiveFileRequestSchema: GenMessage<UnarchiveFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 14);

/**
 * @generated from message chalk.server.v1.UnarchiveFileResponse
 */
export type UnarchiveFileResponse = Message<"chalk.server.v1.UnarchiveFileResponse"> & {
  /**
   * @generated from field: chalk.server.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message chalk.server.v1.UnarchiveFileResponse.
 * Use `create(UnarchiveFileResponseSchema)` to create a new message.
 */
export const UnarchiveFileResponseSchema: GenMessage<UnarchiveFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_files, 15);

/**
 * @generated from enum chalk.server.v1.FileType
 */
export enum FileType {
  /**
   * @generated from enum value: FILE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILE_TYPE_SQL_WORKSHEET = 1;
   */
  SQL_WORKSHEET = 1,
}

/**
 * Describes the enum chalk.server.v1.FileType.
 */
export const FileTypeSchema: GenEnum<FileType> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_files, 0);

/**
 * @generated from enum chalk.server.v1.FileVisibility
 */
export enum FileVisibility {
  /**
   * @generated from enum value: FILE_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILE_VISIBILITY_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: FILE_VISIBILITY_PUBLIC = 2;
   */
  PUBLIC = 2,
}

/**
 * Describes the enum chalk.server.v1.FileVisibility.
 */
export const FileVisibilitySchema: GenEnum<FileVisibility> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_files, 1);

